import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BenefitDto, BenefitsResponseDto } from 'theSource/queries';
import { parseCoreThreeBenefits } from './utils';
import { CoreBenefitsWrapper } from './CoreBenefitsStyled';
import { CoreBenefitCard } from './components';
import { HomePageSection } from '../HomePageSection';
import { ROUTES } from 'theSource/app/routes';
import { getCompanyName } from 'theSource/utils';

interface CoreBenefitsProps {
  benefitsData?: BenefitsResponseDto;
  isLoading: boolean;
  isFetching: boolean;
}

export const CoreBenefits = ({
  benefitsData,
  isLoading,
  isFetching,
}: CoreBenefitsProps) => {
  const [coreBenefits, setCoreBenefits] = useState<BenefitDto[]>([]);
  const { t } = useTranslation('pages.home');
  const isDataLoading = isLoading || isFetching;
  useEffect(() => {
    if (benefitsData) {
      const topThreeBenefits = parseCoreThreeBenefits(benefitsData?.current);
      setCoreBenefits(topThreeBenefits);
    }
  }, [benefitsData]);

  if (!isDataLoading && coreBenefits?.length === 0) {
    return null;
  }

  return (
    <HomePageSection
      title={t('coreBenefits.sectionTitle')}
      viewAllLink={`/${getCompanyName()}${ROUTES.additional.benefits.myBenefits.path}`}
      additionalClasses="order-md-4 order-2 core-benefits-section"
      dataTestId="home-page-section-wrapper"
      id="core-benefits-section"
    >
      <CoreBenefitsWrapper>
        {coreBenefits &&
          coreBenefits.map((benefit, index) => (
            <CoreBenefitCard benefit={benefit} key={index} />
          ))}
      </CoreBenefitsWrapper>
    </HomePageSection>
  );
};
